import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {responsiveBreakpoints, ResponsiveService} from '@core/src/public-api';
import {configVariableValues} from '@shared/constants/config-variable-values.constants';
import {AppConfigService} from '@shared/services/app-config.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'si-appo-request-icon',
  templateUrl: './appo-request-icon.component.html',
  styleUrls: ['./appo-request-icon.component.scss']
})
export class AppoRequestIconComponent {
  subscriptions: Subscription[] = [];
  responsiveBreakPoints = responsiveBreakpoints;
  isMobileWidth: boolean;
  isAppoRequestIconEnabled: boolean;

  constructor(
    private responsiveService: ResponsiveService,
    private router: Router,
    private appConfigService: AppConfigService
  ) {
    this.setResponsiveLogic();
    this.getConfigurations();
  }

  setResponsiveLogic(): void {
    this.subscriptions.push(
      this.responsiveService.getResponsiveStoreObservable().subscribe((responsiveStore) => {
        this.isMobileWidth = responsiveStore.currentWindowWidth < this.responsiveBreakPoints.XS;
      })
    );
  }

  async getConfigurations(): Promise<void> {
    await this.appConfigService.getConfigurations();
    this.isAppoRequestIconEnabled = this.appConfigService.hasConfigurationEnabled(configVariableValues.ALLOW_REQUEST_APPOINTMENT_WITHOUT_IDENTIFICATION);
  }

  onClickButtonAppoRequest(): void {
    this.router.navigate(['/appo-request']);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
